<svg class="svg-splash" [ngClass]="size" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
				viewBox="0 0 32 32" xml:space="preserve">
    <title>{{title}}</title>
    <style type="text/css">
        .st0{fill:#FFFFFF;}
        .st1{fill:#80D957;}
        .st2{fill:#FF924C;}
        .st3{fill:#FF5657;}
    </style>
    <g>
        <g>
            <path class="st0" d="M16.31,0.03c-4.68,0-8.47,3.79-8.47,8.47c0,0.04,0,0.07,0,0.11c0,8.82,8.38,16.01,8.47,16.07
                c0,0,8.47-8.23,8.47-16.07c0-0.04,0-0.07,0-0.11C24.78,3.82,20.99,0.03,16.31,0.03z M16.31,15.46c-1.15,0-2.22-0.3-3.15-0.82
                v-3.75c0-0.44,0.36-0.8,0.8-0.8h2.73v1.6l4.5-2.72l-4.63-2.72v1.75h-2.83c-1.51,0-2.74,1.23-2.74,2.74v1.93
                c-0.72-1.04-1.14-2.3-1.14-3.66c0-3.56,2.89-6.45,6.45-6.45S22.76,5.44,22.76,9C22.76,12.57,19.87,15.46,16.31,15.46z"/>
        </g>
        <g>
            <polygon class="st1" points="8.32,22.81 4.54,31.91 13.21,31.91 13.21,26.7 		"/>
            <path class="st0" d="M13.27,31.97H4.46l0.03-0.08l3.81-9.18l0.06,0.05l4.91,3.91V31.97z M4.62,31.86h8.54v-5.13l-4.81-3.83
                L4.62,31.86z"/>
        </g>
        <g>
            <polygon class="st2" points="9.96,22.51 14.44,26.39 14.44,27.78 26.01,27.78 23.5,22.24 19.93,22.24 16.23,26.35 12.17,22.5 		
                "/>
            <path class="st0" d="M26.1,27.83H14.39v-1.42l-4.58-3.96l2.38-0.01l0.02,0.02l4.01,3.82l3.68-4.09h3.63l0.02,0.03L26.1,27.83z
                 M14.5,27.72h11.43l-2.46-5.43h-3.51l-3.72,4.14l-0.04-0.04l-4.04-3.84l-2.05,0.01l4.4,3.8V27.72z"/>
        </g>
        <g>
            <polygon class="st3" points="14.42,28.54 14.42,31.91 27.46,31.91 26.11,28.54 		"/>
            <path class="st0" d="M27.54,31.97H14.37v-3.49h11.78L27.54,31.97z M14.48,31.86h12.9l-1.31-3.27h-11.6V31.86z"/>
        </g>
    </g>
</svg>